export const shorten = (text: string, cutOff = 100) => {
  if (text.length < cutOff) {
    return text;
  }
  return `${text.substring(0, cutOff)}...`;
};

export const highlight = (text: string, term: string) => {
  let description = text.toLocaleUpperCase();
  let searchTerm = term.toLocaleUpperCase();

  const searchTermStart = description.indexOf(searchTerm);
  const s0 = description.substring(0, searchTermStart);
  const s1 = description.substring(
    searchTermStart,
    searchTermStart + searchTerm.length,
  );
  const s2 = description.substring(
    searchTermStart + searchTerm.length,
    description.length,
  );

  //TODO: customizable highlight accent. right now matches maxtrader pallette
  return (
    <>
      <span>{s0}</span>
      <span className="bold text-orange-500">{s1}</span>
      <span>{s2}</span>
    </>
  );
};
